import { Button, Form, Input } from 'antd';
import React from 'react';
import { useUnits } from './UnitStore';

function Add(props) {
    let {createUnit} = useUnits()
    return (
        <Form layout="vertical" onFinish={createUnit} encType="multipart/form-data">
            <Form.Item name={'nameuz'} label="O'zbekcha nomi">
                <Input />
            </Form.Item>
            <Form.Item name={'nameru'} label="Ruscha nomi">
                <Input />
            </Form.Item>
            <Form.Item name={'shortuz'} label="Qisqartirilgan o'zbekcha">
                <Input />
            </Form.Item>
            <Form.Item name={'shortru'} label="Qisqartirilgan ruscha">
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;